export default "assets/images/icons/contact-phone-5f84ee3d.svg";